module.exports = __webpack_public_path__ + "static/media/how-it-works-step-3.f5eaa931.jpg";